import React, { useState, useEffect, useRef } from 'react';
import { Layout, Row, Col, Button, Spin } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import Navbar from '../../Components/Navbar/Navbar';
import BillingStatement from '../../Components/BillingStatement';
import { UseGetRequest } from '../../Utils/api/ApiRequests';

const ViewMemberBilling = () => {
    const { id } = useParams();
    const [fetching, setFetching] = useState(true);
    const [billingData, setBillingData] = useState({});
    const statementRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: statementRef,
        documentTitle: `Statement-of-Account-${id}`,
        bodyClass: 'soa-print',
    });

    useEffect(() => {
        let isActive = true;

        // Fetch the current SOA and ignore responses after leaving this billing.
        async function fetchBillingData() {
            setFetching(true);
            const response = await UseGetRequest('billings/get_billing', { billing_id: id });
            if (isActive) {
                setBillingData(response.data?.billings?.[0] || {});
                setFetching(false);
            }
        }

        fetchBillingData();
        return () => {
            isActive = false;
        };
    }, [id]);

    return (
        <Layout className='page'>
            <Navbar navKey='credit_billing' />
            <Layout className='content-container overflow-y py-2 px-5'>
                {fetching ? (
                    <Row className='responsive-tab-inline login-right'>
                        <Col span={24} className='center'>
                            <Spin size='large' />
                        </Col>
                    </Row>
                ) : (
                    <>
                        <Row justify='end' className='mb-3'>
                            <Button
                                type='primary'
                                icon={<PrinterOutlined />}
                                onClick={() => handlePrint()}
                                disabled={!billingData.id}
                            >
                                Print SOA
                            </Button>
                        </Row>
                        <div ref={statementRef}>
                            {billingData.id && <BillingStatement billing={billingData} />}
                        </div>
                    </>
                )}
            </Layout>
        </Layout>
    );
};

export default ViewMemberBilling;
